import React from 'react';
import { FaSignInAlt } from 'react-icons/fa';
import { redirectToLogin } from '../api/auth';

function LoginPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-4">
      <div className="card text-center w-full max-w-md">
        <img
          src={`${process.env.PUBLIC_URL}/images/cloudza-logo.png`}
          alt="Cloudza Logo"
          className="w-40 h-auto mx-auto mb-6 object-contain"
        />
        <h1 className="text-2xl font-semibold mb-6">Post-Call Analytics</h1>
        <button
          onClick={redirectToLogin}
          className="btn-primary w-full justify-center"
        >
          <FaSignInAlt className="h-5 w-5" />
          <span>Sign In</span>
        </button>
      </div>
    </div>
  );
}

export default LoginPage;
